import { createTestOverviewTypes } from '../../common/test-overview/types';

export const NAMESPACE = 'analytics-test-overview-rdc';
export default createTestOverviewTypes(NAMESPACE);
